export const checkSamplesPresent = async (
    classes,
    samplesDb,
    modelId,
    isAudioTrain
) => {
    const allSamples = await samplesDb.getAll();

    for(const classKey in classes){
        const classSamples = allSamples.filter((s) =>
            s.modelId === modelId &&
            String(s.classId) === String(classKey) &&
            (isAudioTrain ? s.sampleType !== 'Image' : s.sampleType === 'Image')
        )

        // Warn below 10 samples per class for both image and audio training.
        const minSamples = 10

        if(classSamples.length === 0){
            return {status:true, classKey, sampleNumber:0}
        }

        if(classSamples.length < minSamples){
            return{
                status: true,
                classKey,
                sampleNumber: classSamples.length
            }
        }
    }
    return {
        status: false,
        sampleNumber: 0,
        classKey:""
    }
}